import { useState, useEffect } from "react"; 

function useSupercheckout(reloadOnSuccess = true) {
    const [isPaymentSuccess, setIsPaymentSuccess] = useState(false);
    const [isCheckoutOpened, setIsCheckoutOpened] = useState(false);
  
    useEffect(() => {
      if(isPaymentSuccess && !isCheckoutOpened) {
        reloadOnSuccess && location.reload();
      }
    }, [isPaymentSuccess, isCheckoutOpened]);
  
    function openCheckout({entity_type, entity_id, onPaymentSuccess, onClose, booking_date, start_at}) {

      const handleOnPaymentSuccess = (...args) => {
        console.log('web - payment success...', args);
        setIsPaymentSuccess(true);
  
        onPaymentSuccess && onPaymentSuccess();
      };
    
      const handleOnClose = (...args) => {
        console.log('web - closed payment modal...', args);
        setIsCheckoutOpened(false);
  
        onClose && onClose();
      };    

      const options = {
        entity_type: entity_type,
        entity_id: entity_id,
        booking_date: booking_date,
        start_at: start_at,
        on_payment_success: handleOnPaymentSuccess,
        on_close: handleOnClose,
        notes: {},
      };
  
      if (window.qoohoo) {
        const checkout = new qoohoo(options);
        checkout.open();
        setIsCheckoutOpened(true);
      }
    }

    return openCheckout;
}

export default useSupercheckout